import { RedirectFormControls } from 'app/components/management/common/plugins/redirect/form-controls';
import { CustomPluginFormControls } from 'app/components/management/common/plugins/custom/form-controls';
import { redirectFormValidationSchema } from 'app/components/management/common/plugins/redirect/validation-scheme';
import { ActionBasedFormControls } from 'app/components/management/common/plugins/action-based/form-controls';
import { actionBasedFormValidationSchema } from 'app/components/management/common/plugins/action-based/validation-scheme';
import { customFormValidationSchema } from 'app/components/management/common/plugins/custom/validation-scheme';
import { ViewSegment as ActionViewSegment } from 'app/components/management/common/plugins/action-based/view-segment';
import { ViewSegment as CustomViewSegment } from 'app/components/management/common/plugins/custom/view-segment';
import { QuizFormControls } from 'app/components/management/common/plugins/quiz/quiz-form-control';
import { quizFormValidationSchema } from 'app/components/management/common/plugins/quiz/quiz-validation-schema';

export interface PluginFormControlsProps {
  metadata: any;
  errors: any;
  onChange: (metadata: any) => void;
}

export interface PluginViewSegmentProps {
  metadata: any;
}

interface PluginFormData {
  formComponent: React.FC<PluginFormControlsProps>;
  validationSchema: any;
  viewSectionComponent?: React.FC<PluginViewSegmentProps>;
}

export const pluginFormControlMap: Record<number, PluginFormData> = {
  2: { formComponent: RedirectFormControls, validationSchema: redirectFormValidationSchema },
  3: {
    formComponent: CustomPluginFormControls,
    validationSchema: customFormValidationSchema,
    viewSectionComponent: CustomViewSegment
  },
  4: {
    formComponent: ActionBasedFormControls,
    validationSchema: actionBasedFormValidationSchema,
    viewSectionComponent: ActionViewSegment
  },
  5: {
    formComponent: QuizFormControls,
    validationSchema: quizFormValidationSchema
  }
  // ...
};
